module.exports = __webpack_public_path__ + "static/media/gg_thumbnail.5e11e5c7.png";